import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class CmsNavbarService {

  private userInputs = new BehaviorSubject<any>('');
  userInputs$ = this.userInputs.asObservable();

  constructor(private http: HttpClient) { }

  publishUserInputs(inputs: any) {
    this.userInputs.next(inputs);
  }

  getAllBodiesList(): Observable<any> {
    return this.http.get('model-map/bodyList',{withCredentials : true});
  }
  getAllMakeList(): Observable<any> {
    return this.http.get('common/makeList',{withCredentials : true});
  }
  getMainGroupsList(): Observable<any> {
    return this.http.get('common/mainGroupList',{withCredentials : true});
  }
  getMainGroupsListbyMakeName(MakeName):Observable<any>{
    return this.http.get(`common/mainGroupListWithMake?make=${MakeName}`,{withCredentials : true})
  }

  getOriginCheckerForEPCLink(): Observable<any> {
    return this.http.get('common/originChecker',{withCredentials : true});
  }
  getUniqueTechDocNumber(): Observable<any> {
    return this.http.get(`tech-doc/nextDocumentNumber`);
  }
  getUniqueEquipementManual(): Observable<any> {
    return this.http.get(`equipment-manual/nextDocumentNumber`);
  }

}
